import { NetworkStatus, useQuery } from "@apollo/client";
import { useEffect } from "react";

import { Flag } from "@medbillai/utils/flag";

import { useAuth } from "../../../lib/auth";
import { useBoolVariation } from "../../../lib/flag";
import { useAppState } from "../../../lib/useAppState";
import { showWelcomeScreenQuery } from "./queries";

export const useWelcome = () => {
  const forceShowWelcomeScreen = useBoolVariation(
    Flag.FORCE_SHOW_WELCOME_SCREEN,
    false,
  );
  const { isActive } = useAppState();
  const { isAuthenticated, isReady } = useAuth();

  const { data, loading, refetch, networkStatus } = useQuery(
    showWelcomeScreenQuery,
    {
      skip: !isAuthenticated || !isReady,
    },
  );

  // Refetch when app becomes active after being backgrounded.
  // Only refetch if we're authenticated and ready - refetch() bypasses the skip
  // condition so we need to check auth state here to avoid errors when the
  // session has expired while the app was backgrounded.
  // biome-ignore lint/correctness/useExhaustiveDependencies: networkStatus intentionally excluded to prevent infinite loop
  useEffect(() => {
    if (
      isActive &&
      isAuthenticated &&
      isReady &&
      networkStatus !== NetworkStatus.refetch &&
      networkStatus !== NetworkStatus.loading
    ) {
      void refetch();
    }
  }, [isActive, isAuthenticated, isReady, refetch]);

  const shouldShow = forceShowWelcomeScreen || data?.showWelcomeScreen;

  return { shouldShow, loading, refetch };
};
